class CstController extends AbstractController
  @$inject = ['$injector', 'pathService', 'cstService']

  constructor: ($injector, pathService, @cstService) ->
    super($injector)

    url = pathService.getViewUrl() + 'eficiencia-fiscal/view/configuracao/cst/'
    @modalCst = @openPopup(url + 'modal.html', 'cstModalController as ctrl', null, 'static')
    @loadingTracker = @promiseTracker()

  list: (type) ->
    @loadingTracker.addPromise(
      @cstService.getListByType(type, (data) =>
        @listOfCsts = data
      )
    ) if type?

  adicionar: (type) ->
    @modalCst({
      type: -> type
      cst: -> {}
    }, (result) => @list(type))

  editar: (type, cst) ->
    @modalCst({
      type: -> type
      cst: -> angular.copy cst
    }, (result) => @list(type))

  remover: (type, cst) ->
    @Confirm.warning("Atenção!",
      "Deseja realmente remover a configuração de <strong>Cst #{type} - #{cst.descricao}</strong>? Essa ação não poderá ser desfeita.", {
        'Sim': =>
          @cstService.delete(cst.id, =>
            Alert.success("Configuração <strong>#{cst.descricao}</strong> removida com sucesso.")
            @list(type)
          )
        'Não': null
      })

angular.module("eficienciaFiscalModule").controller('cstController', CstController)

class CstModalController extends AbstractController
  @$inject = ['$injector', '$uibModalInstance', 'cstService', 'type', 'cst']

  constructor: ($injector, @modalInstance, @cstService, type, cst) ->
    super($injector)

    @submitTracker = @promiseTracker()

    @cst = cst
    @cst.type = type
    @cst.inicio = new Date(cst.inicio) if cst.inicio?

  salvar: (form, data) ->
    if form.$valid
      @submitTracker.addPromise(
        @cstService.save(angular.copy(data), (result) =>
          if result.success
            @Alert.success("A Configuração <strong>Cst #{data.type} - #{data.descricao}</strong> adicionada.", 'Sucesso')
            @modalInstance.close()

          @Alert.warning('O tipo da <strong>Cst</strong> não foi enviada. Tente novamente', 'Operação não realizada', 15000) unless result.success
        )
      ) unless data.id
      @submitTracker.addPromise(
        @cstService.update(angular.copy(data), (result) =>
          @Alert.success("A Configuração <strong>Cst #{data.type} - #{data.descricao}</strong> atualizado.", 'Sucesso')
          @modalInstance.close()
        )
      ) if data.id


angular.module("eficienciaFiscalModule").controller('cstModalController', CstModalController)